import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mobile-container',
  templateUrl: './mobile-container.component.html',
  styleUrls: ['./mobile-container.component.scss']
})
export class MobileContainerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
